import type {
  ApiBlock,
  BlockType,
  _ApiBlock,
} from '@backmarket/http-api/src/api-specs-content/models/block'

/**
 * Finds the first block of a given type in a CMS page content blocks array.
 *
 * Nuxt's `useAsyncData` wraps the `ApiBlock` discriminated union in
 * `SerializeObject`, which prevents TypeScript from narrowing `block.props`
 * based on `block.type`. This helper encapsulates the necessary cast so
 * consumers get properly typed props without casting at call sites.
 */
export function findBlockByType<T extends BlockType>(
  blocks: ApiBlock[] | undefined,
  type: T,
): _ApiBlock<T> | undefined {
  const block = blocks?.find((b) => b.type === type)

  return block as _ApiBlock<T> | undefined
}
